@let expandedClass = expanded();
@if (user.isSelf) {
  <div class="user-entry {{ expandedClass }} self">
    <div
      class="user-avatar"
      [andorContextMenuTriggerFor]="selfSettings"
      [andorTooltip]="user.data.name"
      tooltipPosition="left"
      [tooltipDisabled]="!showTooltip">
      <andor-user-avatar [user]="user"></andor-user-avatar>
    </div>
    @if (expandedClass) {
      <div class="info">
        <div class="name">
          <div class="self">{{ user.data.name }}</div>
        </div>
        <div class="status">
          <andor-user-status-btn
            [status]="user.data.statusMessage ?? user.data.status"
            [isOnline]="user.data.status"
            (toggle)="onStatusToggle()"></andor-user-status-btn>
        </div>
      </div>
      <div class="actions">
        <andor-icon-btn
          [andorContextMenuTriggerFor]="selfSettings"
          aria-label="Button to open settings for {{ user.data.name }}">
          <fa-duotone-icon [animation]="iconAnimation()" [icon]="faGear"></fa-duotone-icon>
        </andor-icon-btn>
      </div>
    }
  </div>

  <andor-context-menu
    #selfSettings
    mode="styled"
    xPosition="before"
    (opened)="onMenuOpened()"
    (closed)="onMenuClosed()">
    <div class="self-settings">
      <andor-settings-profile></andor-settings-profile>
    </div>
  </andor-context-menu>
} @else {
  <div
    class="user-entry {{ expandedClass }}"
    [class.favorite]="user.isFavorite"
    (click)="onTileClick($event)">
    <div
      class="user-avatar"
      [andorContextMenuTriggerFor]="participantSettings"
      [andorTooltip]="user.data.name"
      tooltipPosition="left"
      [tooltipDisabled]="!showTooltip">
      <andor-user-avatar [user]="user"></andor-user-avatar>
    </div>
    @if (expandedClass) {
      <div class="info">
        <div class="name">
          <div>{{ user.data.name }}</div>
          @if (user.isFavorite) {
            <fa-icon
              class="favorite-icon"
              role="img"
              [icon]="faStar"
              [attr.aria-label]="'Favorite' | translate"></fa-icon>
          }
        </div>
        <div class="status">
          <andor-user-status-btn
            [status]="user.data.statusMessage ?? user.data.status"
            [isOnline]="user.data.status"
            (toggle)="onStatusToggle()"></andor-user-status-btn>
        </div>
      </div>
      <div class="actions">
        <andor-icon-btn
          [andorContextMenuTriggerFor]="participantSettings"
          aria-label="Button to open settings for {{ user.data.name }}">
          <fa-duotone-icon [animation]="iconAnimation()" [icon]="faEllipsis"></fa-duotone-icon>
        </andor-icon-btn>
      </div>
    }
  </div>

  <andor-context-menu
    #participantSettings
    mode="styled"
    xPosition="before"
    (opened)="onMenuOpened()"
    (closed)="onMenuClosed()">
    <andor-participant-mini-profile [user]="user"></andor-participant-mini-profile>
  </andor-context-menu>
}
